"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var react_stateful_1 = require("@nexys/react-stateful");
var CrudRoutes = (function () {
    function CrudRoutes(urlPrefix) {
        var _this = this;
        this.list = function () { return react_stateful_1.Request.post(_this.urlPrefix + "/list"); };
        this.detail = function (uuid) {
            return react_stateful_1.Request.post(_this.urlPrefix + "/detail", { id: Number(uuid) });
        };
        this.insert = function (data) {
            return react_stateful_1.Request.post(_this.urlPrefix + "/insert", __assign({}, data));
        };
        this.update = function (data) {
            return react_stateful_1.Request.post(_this.urlPrefix + "/update", __assign({}, data));
        };
        this.deleteById = function (id) {
            return react_stateful_1.Request.post(_this.urlPrefix + "/delete", { id: id });
        };
        this.urlPrefix = urlPrefix;
    }
    return CrudRoutes;
}());
exports["default"] = CrudRoutes;
